import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getTransfers: async (params) => await apiClient.get(endpoints.getAll(), { params }),
  getTransferById: async (id) => await apiClient.get(endpoints.getById(id)),
  getTransferFiles: async (id) => await apiClient.get(endpoints.getFiles(id)),
  requestTransferFile: async (id, featureCategory) => await apiClient.post(endpoints.requestFile(id, featureCategory)),
  getTransferReservations: async ({ id, ...params }) => {
    return await apiClient.get(endpoints.getTransferReservations(id), { params });
  },
};
